<template>
  <div id="location-index-list">
    <b-collapse :visible="visible" :id="collapseId" class="locations-collapse">
      <div class="locations">
        <div class="locations__inner">
        <Loading v-if="loading" color="black" />
        <template v-else>
          <template v-for="(heading, index) in allLocationsList">
            <div :key="`heading-${index}`" class="locations__heading">
              {{ heading.heading }}
            </div>
            <ul :key="`list-${index}`" class="locations__list">
              <li v-for="(location, index) in heading.locations"
                  :key="`${index}-${location.id}`"
                  class="locations__list__item"
              >
                <router-link :to="setRouteObject(location.locationname)">
                  {{ location.locationname }}
                </router-link>
              </li>
            </ul>
          </template>
        </template>
      </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import Loading from "@/components/ui/Loading";
import axios from "axios";
export default {
  name: "LocationIndexList",
  components: {
    Loading,
  },
  props: {
    collapseId: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    allLocationsList: [],
    loading: false,
    routeName: ''
  }),
  mounted() {
    this.onCollapseStateChange();
  },
  methods: {
    setRouteObject(locationName){
      if(this.$route.path.includes('location') && this.$route.name === 'discover-location') {
        return {name: 'location-id-residents', params: {id: locationName}}
      } else if(this.$route.path.includes('location') && this.$route.name !== 'discover-location') {
        return {name: this.$route.name, params: {id: locationName}}
      } else {
        return {name: 'discover-location'}
      }
    },
    onCollapseStateChange(){
      this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
        if (collapseId === this.collapseId) {
          if (!(!isJustShown || this.allLocationsList.length)) { // get locations once
            // Get data only once
            this.getAllLocationsPaged();
          }
        }
      });
    },
    getAllLocationsPaged() {
      this.loading= true;
      axios
          .get(`${this.$router.options.api}/location/all-locations`)
          .then(response => {
            this.allLocationsList = this.setHeadingKey(response.data);
            this.loading = false;
          })
          .catch(error => {
            console.log(error);
          });
    },
    setHeadingKey(array) {
      let data = array.reduce((r, e) => {
        // get first letter of artist name of current element
        let heading = e.locationname[0].toLowerCase();
        // if there is no property in accumulator with this letter create it
        if (!r[heading]) {
          r[heading] = {heading, locations: [e]};
        }
        // if there is push current element to children array for that letter
        else {
          r[heading].locations.push(e);
        }
        // return accumulator
        return r;
      }, {});
      return Object.values(data);
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/sass/abstracts/_variables.scss";
.locations-collapse {
  top: 0;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.locations{
  height: calc(100vh - var(--headerHeight) - 120px);
  overflow-y: scroll;
  margin-top: calc(var(--headerHeight) + 120px);
  background-color: $c_light_grey_fill;
  @include media-breakpoint-down(lg) {
    height: calc(100vh - var(--headerHeight) - 100px);
    margin-top: calc(var(--headerHeight) + 100px);
  }
  &__inner {
    //max-width: 1167px;
    margin:0 auto;
    padding: 25px 28px;
    @include media-breakpoint-down(lg){
      padding: 25px 20px 80px 20px;
    }
    @include media-breakpoint-up(xxxl){
      max-width: 100%;
      padding: 25px 20px;
    }
  }
  &__heading {
    text-transform: uppercase;
    border-bottom: 1px solid black;
    width: 150px;
    margin: 15px 0;
    padding-bottom: 5px;
    @include font-18-md;
  }
  &__list {
    padding:0;
    list-style: none;
    margin:0 0 40px 0;
    &__item {
      display: flex;
      a {
        @include font-14-md;
        color: $c_medium_grey;
        text-transform: capitalize;
        padding: 3px 0;
        &.router-link-active {
          color: $c_black;
        }
        &:hover {
          color: $c_base;
        }
      }
    }
  }
}

</style>
